import { Component, OnInit } from '@angular/core';
import {AppDataServiceService} from 'src/app/app-data-service.service'
//mport {LeftAsideService} from 'src/app/leftAside/left-aside.service'
import { Router } from '@angular/router';
//import { LeftAsideComponent } from 'src/app/leftAside/leftAside.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
    public newDate:string;
  constructor( 
    private _networkService:AppDataServiceService,
    private dates:AppDataServiceService,
   // private _dataShareingService:LeftAsideComponent,
    public router: Router,
  //  private dates:LeftAsideComponent

    ) { }



 

  ngOnInit() {
     // alert("hello");
      
  }
  open_pannel = false;

  togglePannel(flag){
    this.open_pannel = !flag
  }
  allDeviceEnergy(){
    this.togglePannel(false);
    this.router.navigate(['/dashboard', {outlets: {'footer': ['all_device_graph']}}]);
 }

}

